import { useState, useEffect } from "react";
import { X } from "lucide-react";
import axios from "axios";

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const PromoBar = () => {
  const [promoSettings, setPromoSettings] = useState({ enabled: false, html_content: "" });
  const [isVisible, setIsVisible] = useState(true);

  // Add/remove body class when promo bar visibility changes
  useEffect(() => {
    if (promoSettings.enabled && isVisible && promoSettings.html_content.trim()) {
      document.body.classList.add('promo-bar-visible');
    } else {
      document.body.classList.remove('promo-bar-visible');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('promo-bar-visible');
    };
  }, [promoSettings.enabled, isVisible, promoSettings.html_content]);

  useEffect(() => {
    // Fetch promo bar settings
    const fetchPromoSettings = async () => {
      try {
        const response = await axios.get(`${API}/promo-bar-settings`);
        setPromoSettings(response.data);
      } catch (error) {
        console.error("Error fetching promo bar settings:", error);
      }
    };

    fetchPromoSettings();
  }, []);

  // Don't render if not enabled or not visible or no content
  if (!promoSettings.enabled || !isVisible || !promoSettings.html_content.trim()) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-orange-500 text-white shadow-lg promo-bar">
      <div className="container mx-auto px-4 py-2 flex items-center justify-between">
        <div 
          className="flex-1 text-center text-sm font-medium"
          dangerouslySetInnerHTML={{ __html: promoSettings.html_content }}
        />
        <button
          onClick={() => setIsVisible(false)}
          className="ml-4 p-1 hover:bg-orange-600 rounded transition-colors flex-shrink-0"
          aria-label="Close promo bar"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default PromoBar;